import { create } from "zustand";

export type AssociateMessageFilters = {
  lifecycle?: {
    category: string;
    values: string[];
    excludeValues: string[];
  };
  section?: string;
};

export type AssociateMessagePayload = {
  moduleId?: string | number;
  filters?: AssociateMessageFilters;
};

/** One sub-object row in `ptCallActivityAssociateProps` postMessage payload. */
export type CallActivityObjectRecord = {
  objectId: string;
  moduleId: number | string;
  /** Host module filters for pre-process list v2 (per record) */
  filters?: AssociateMessageFilters;
};

export type CallActivityAssociateMessagePayload = {
  paModuleId: string | number;
  paObjectId: string;
  callActivityDefinitionId: string;
  subObjectRecords: CallActivityObjectRecord[];
};

type ProcessMessageStore = {
  associateMessageData?: AssociateMessagePayload;
  callActivityAssociateMessageData?: CallActivityAssociateMessagePayload;
  setAssociateMessage: (params: AssociateMessagePayload) => void;
  setCallActivityAssociateMessage: (
    data: CallActivityAssociateMessagePayload
  ) => void;
};

export const useProcessMessageStore = create<ProcessMessageStore>((set) => ({
  associateMessageData: undefined,
  callActivityAssociateMessageData: undefined,
  setAssociateMessage(data) {
    let normalizedModuleId: string | undefined;
    if (data.moduleId !== null && typeof data.moduleId !== "undefined") {
      normalizedModuleId = String(data.moduleId);
    }

    set(() => ({
      associateMessageData: {
        moduleId: normalizedModuleId,
        filters: data.filters,
      },
    }));
  },
  setCallActivityAssociateMessage(data) {
    set(() => ({
      callActivityAssociateMessageData: data,
    }));
  },
}));
